export const DECISION_APPROVAL_LEVEL_APPLIED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Decision.DecisionApprovalLevelApplied";
export const DECISION_APPROVAL_LEVEL_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Decision.DecisionApprovalLevelUpdated";
